import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function humanNameValidator(): ValidatorFn {
  // Allows: any letter from any language, spaces, apostrophes, hyphens, and period (dot)
  const namePattern = /^[\p{L}' .-]+$/u;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; // skip empty values, let Validators.required handle that
    return namePattern.test(value) ? null : { invalidHumanName: { actual: value } };
  };
}
